import React__default from 'react';
import styled from 'styled-components';
import { themeGet } from '../../utils/theme-get.js';
import sx from '../../sx.js';
import Box from '../Box/Box.js';

const Wrapper = styled(Box).withConfig({
  displayName: "AtlasButtonGroup__Wrapper",
  componentId: "sc-u6242g-0"
})(["display:inline-flex;gap:", ";& > *{flex:1 0 auto;}", ""], themeGet('space.1'), sx);
const AtlasButtonGroup = ({
  appearance,
  children,
  ...props
}) => {
  return /*#__PURE__*/React__default.createElement(Wrapper, props, React__default.Children.map(React__default.Children.toArray(children), (child, idx) => {
    if (!child) {
      return null;
    }
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      React__default.createElement(React__default.Fragment, {
        key: idx
      }, appearance ? /*#__PURE__*/React__default.cloneElement(child, {
        appearance
      }) : child)
    );
  }));
};
AtlasButtonGroup.displayName = "AtlasButtonGroup";
AtlasButtonGroup.displayName = 'AtlasButtonGroup';

export { AtlasButtonGroup };
